import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

// Tiles shown before the button appears. Two rows of three at the widest and
// three rows of two below it, so the opening set is whole rows at every width.
const TILE_PAGE = 6;

/*
    Subcategories of a level-1 category, as thumbnail tiles with the name laid
    over the bottom of the image.

    A category with more of them than one set opens with the first set and a
    button for the rest. Every tile is in the HTML either way, the ones past the
    set being hidden rather than left out, so each subcategory page is linked
    from its parent whether or not the button is ever pressed.
*/
const SubcategoryTiles = ({ ariaLabel = 'Subcategories', basePath, categories }) => {
    const [shown, setShown] = useState(TILE_PAGE);

    if (!categories || !categories.length) return null;

    const held = categories.length;
    const visible = Math.min(shown, held);

    return (
        <nav className="subcategory-tiles" aria-label={ariaLabel}>
            <div className="constrain-width large">
                <div className="tile-grid">
                    {categories.map(({ id, name, slug, thumbnail }, index) => (
                        <article
                            key={id}
                            className="subcategory-tile"
                            hidden={index >= visible ? true : undefined}>
                            <Link
                                to={`${basePath}/${slug}`}
                                className="subcategory-tile-link"
                                style={thumbnail ? { backgroundImage: `url(${thumbnail})` } : null}
                            >
                                <h3 className="title">{name}</h3>
                            </Link>
                        </article>
                    ))}
                </div>
                {visible < held &&
                    <div className="subcategory-tiles-actions">
                        <button
                            type="button"
                            className="button primary"
                            onClick={() => setShown(visible + TILE_PAGE)}>
                            Load more
                        </button>
                    </div>
                }
            </div>
        </nav>
    );
};

SubcategoryTiles.propTypes = {
    ariaLabel: PropTypes.string,
    basePath: PropTypes.string.isRequired,
    categories: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        slug: PropTypes.string,
        thumbnail: PropTypes.string
    }))
};

export default SubcategoryTiles;
